export default {
  parent_surveys: []
};